module.exports = __webpack_public_path__ + "static/media/dogs-questions.4c7d5ff3.csv";